import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { LeafCollectionSummaryReportSchemaObject } from "../LeafCollectionSummaryReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import _ from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import xlsx from 'json-as-xlsx';

const screenCode = "DAILYROUTESUMMARYWITHGAINANDLOSSREPORTFIN";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    },
    stickyHeader: {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
    stickyColumn: {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        backgroundColor: 'white',
    },
});

export function LeafCollectionSummaryFINReportWithOutVehicel(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [factories, setFactories] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const date = new Date(); date.setDate(date.getDate() - 1);
    const [leafCollectionDetails, setLeafCollectionDetails] = useState({
        groupID: "0",
        factoryID: "0",
        routeID: "0",
        fromDate: date.toISOString().split("T")[0],
        toDate: date.toISOString().split("T")[0]
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        factory: "0",
        route: "0",
        fromDate: "",
        toDate: ""
    });
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(LeafCollectionSummaryReportSchemaObject).options({ allowUnknown: true });
    const [mergedReportData, setMergedReportData] = useState([]);
    const [totalValues, setTotalValues] = useState({
        totalBagCount: 0,
        totalFieldGrossAmount: 0,
        totalFieldNetAmount: 0,
        totalFactoryGrossAmount: 0,
        totalFactoryNetAmount: 0,
        totalVariance: 0,
        totalFieldActualAmount: 0,
        totalFactoryActualAmount: 0
    });
    const [csvData, setCsvData] = useState([]);
    const csvHeaders = [
        { label: "Date", value: "date" },
        { label: "Route Name", value: "route" },
      //  { label: "Vehicle", value: "fieldVehicle" },
        { label: "Actual Amount (Field)", value: "fieldActualAmount" },
        { label: "Gross Amount (Field Weight)", value: "fieldGrossAmount" },
        { label: "Net Amount (Field Weight)", value: "fieldNetAmount" },
        { label: "Actual Amount (Factory)", value: "factoryActualAmount" },
        { label: "Gross Amount (Factory Weight)", value: "factoryGrossAmount" },
        { label: "Net Amount (Factory Weight)", value: "factoryNetAmount" },
      //  { label: "Gross Variance", value: "totVariance" },
     //   { label: "Field Variance", value: "totVariance" }
    ];

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getFactoriesForDropdown(),
        )
    }, [leafCollectionDetails.groupID])

    useEffect(() => {
        trackPromise(
            getRoutesForDropDown()
        )
    }, [leafCollectionDetails.factoryID])

    // useEffect(() => {
    //     if (mergedReportData.length != 0) {
    //         calculateTotal()
    //     }
    // }, [mergedReportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: target.value,
            factoryID: "0",
            routeID: "0"

        });
        clearTableData();
    }

    function handleFactoryChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            factoryID: target.value,
            routeID: "0"
        });
        clearTableData();
    }

    function handleRouteChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: target.value,
        });
        clearTableData();
    }

    function handleFromDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            fromDate: target.value,
        });
        clearTableData();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            toDate: target.value,
        });
        clearTableData();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, LeafCollectionSummaryReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYROUTESUMMARYWITHGAINANDLOSSREPORTFIN');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setLeafCollectionDetails({
            ...leafCollectionDetails,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }


    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getFactoriesForDropdown() {
        const data = await services.getFactoriesByGroupID(leafCollectionDetails.groupID);
        setFactories(data);
    }

    async function getRoutesForDropDown() {
        const data = await services.getAllRoutesByFactoryID(leafCollectionDetails.factoryID);
        setRoutes(data);
    }


    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }


    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);

        const errorMessages = validate(schema, leafCollectionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(leafCollectionDetails);

        const result = await services.getLeafCollectionSummaryReportData(leafCollectionDetails);

        const factoryResultData = result.factoryData;
        const fieldResultData = result.fieldData;

        const combinedData = factoryResultData.concat(fieldResultData);

        const groupedData = combinedData.reduce((acc, obj) => {
            const key = obj.date.split("T")[0] + obj.route;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(obj);
            return acc;
        }, {});
        const finalResult = Object.values(groupedData).map(group => {
            return group.reduce((acc, item) => ({
                date: item.date.split("T")[0],
                route: item.route,
                fieldGrossAmount: acc.fieldGrossAmount || item.fieldGrossAmount,
                fieldNetAmount: acc.fieldNetAmount || item.fieldNetAmount,
                factoryGrossAmount: acc.factoryGrossAmount || item.factoryGrossAmount,
                factoryNetAmount: acc.factoryNetAmount || item.factoryNetAmount,
                factoryActualAmount: acc.factoryActualAmount || item.factoryActualAmount,
                fieldActualAmount: acc.fieldActualAmount || item.fieldActualAmount
            }), {});
        });
        calculateTotal(finalResult);
        setMergedReportData(finalResult);
        setCsvData(finalResult);
    }

    function calculateTotal(finalResult) {
        
        const totalFieldGrossAmount = finalResult.reduce((accumulator, current) => {
            const progressFraction = isNaN(current.fieldGrossAmount) ? 0 : current.fieldGrossAmount;
            return accumulator + progressFraction;
        }, 0);

        const totalFieldNetAmount = finalResult.reduce((accumulator, current) => {
            const progressFraction = isNaN(current.fieldNetAmount) ? 0 : current.fieldNetAmount;
            return accumulator + progressFraction;
        }, 0);

        const totalFactoryGrossAmount = finalResult.reduce((accumulator, current) => {
            const progressFraction = isNaN(current.factoryGrossAmount) ? 0 : current.factoryGrossAmount;
            return accumulator + progressFraction;
        }, 0);

        const totalFactoryNetAmount = finalResult.reduce((accumulator, current) => {
            const progressFraction = isNaN(current.factoryNetAmount) ? 0 : current.factoryNetAmount;
            return accumulator + progressFraction;
        }, 0);

        const totalFieldActualAmount = finalResult.reduce((accumulator, current) => {
            const progressFraction = isNaN(current.fieldActualAmount) ? 0 : current.fieldActualAmount;
            return accumulator + progressFraction;
        }, 0);

        const totalFactoryActualAmount = finalResult.reduce((accumulator, current) => {
            const progressFraction = isNaN(current.factoryActualAmount) ? 0 : current.factoryActualAmount;
            return accumulator + progressFraction;
        }, 0);


        const totalVariance = totalFactoryNetAmount - totalFieldNetAmount;

        setTotalValues({
            ...totalValues,
         //   totalBagCount: totalBagCount,
            totalFieldGrossAmount: totalFieldGrossAmount,
            totalFieldNetAmount: totalFieldNetAmount,
            totalFactoryGrossAmount: totalFactoryGrossAmount,
            totalFactoryNetAmount: totalFactoryNetAmount,
            totalVariance: totalVariance,
            totalFieldActualAmount: totalFieldActualAmount,
            totalFactoryActualAmount: totalFactoryActualAmount
        });
    }

    function createFile() {
        var settings = {
            sheetName: 'Leaf Collection Report',
            fileName: 'LeafCollectionSummaryReport',
            writeOptions: {}
        }
        var newRow1 = {
            date: "Group :" + selectedSearchValues.group,
            route: "Factory : " + selectedSearchValues.factory,
          //  fieldVehicle: selectedSearchValues.route == undefined ? 'Route : All Routes' : "Route : " + selectedSearchValues.route,
            fieldGrossAmount: "From Date : " + selectedSearchValues.fromDate,
            fieldNetAmount: "To Date : " + selectedSearchValues.toDate
        }
        csvData.push({}, {}, newRow1)
        xlsx(csvHeaders, mergedReportData, settings, true)
    }

    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setLeafCollectionDetails({
            ...leafCollectionDetails,
            routeID: "0",
            fromDate: "",
            toDate: ""
        });
        setErrors("");
        clearTableData();
    }

    function clearTableData() {
        setIsTableHide(true);
        setMergedReportData([]);
    }


    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            factory: factories[searchForm.factoryID],
            route: routes[searchForm.routeID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate,
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Daily Route Summary With Variance Report"
                                isButtonEnable={permissionList.isAddEditEnabled}
                            />
                        </div>

                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={leafCollectionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="factoryID"
                                            id="factoryID"
                                            name="factoryID"
                                            value={leafCollectionDetails.factoryID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleFactoryChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Route </InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="routeID"
                                            id="routeID"
                                            name="routeID"
                                            value={leafCollectionDetails.routeID}
                                            onChange={(e) => handleRouteChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={leafCollectionDetails.fromDate}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            value={leafCollectionDetails.toDate}
                                        />
                                        {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, leafCollectionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>

                            {mergedReportData.length > 0 ?
                                <TableContainer component={Paper} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", maxHeight: '800px', overflowY: 'auto' }}>
                                    <Table className={classes.table} style={{ borderCollapse: 'collapse', border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} size="small" aria-label="sticky table" stickyHeader>
                                        <TableHead className={`${classes.stickyHeader}`}>
                                            <TableRow className={`${classes.stickyHeader}`} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }}>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Date
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Route Name
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={3} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px", backgroundColor: "lightgreen" }}>
                                                    Field Weight / Kg
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" colSpan={3} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px", backgroundColor: "lightblue" }}>
                                                    Factory Weight / Kg
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Actual Variance
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Gross Variance
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Net Variance
                                                </TableCell>
                                            </TableRow>
                                            <TableRow className={`${classes.stickyHeader}`} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }}>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Actual Amount
                                                </TableCell>
                                                {/* <TableCell align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Bag Count
                                                </TableCell> */}
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Gross Amount
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Net
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" rowSpan={2} style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Actual Amount
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Gross Amount
                                                </TableCell>
                                                <TableCell className={`${classes.stickyHeader}`} align="center" style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold", width: "250px" }}>
                                                    Net
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {mergedReportData.map(row => (
                                                <TableRow >
                                                    <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="center">
                                                        {(row.date).split("T")[0]}
                                                    </TableCell>
                                                    <React.Fragment >
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {row.route}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {isNaN(row.fieldActualAmount) ?  '-' : (row.fieldActualAmount)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {isNaN(row.fieldGrossAmount) ? '-' : (row.fieldGrossAmount)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {isNaN(row.fieldNetAmount) ? '-' : (row.fieldNetAmount)}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {isNaN(row.factoryActualAmount) ? '-' : row.factoryActualAmount}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {isNaN(row.factoryGrossAmount) ? '-' : row.factoryGrossAmount}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {isNaN(row.factoryNetAmount) ? '-' : row.factoryNetAmount}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {(row.fieldActualAmount > 0 && row.factoryActualAmount > 0) ? ((row.factoryActualAmount) - (row.fieldActualAmount)).toFixed(2) : '-'}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {(row.factoryGrossAmount > 0 && row.fieldGrossAmount > 0) ? ((row.factoryGrossAmount) - (row.fieldGrossAmount)).toFixed(2) : '-'}
                                                        </TableCell>
                                                        <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                            {(row.factoryNetAmount > 0 && row.fieldNetAmount > 0) ? ((row.factoryNetAmount) - (row.fieldNetAmount)).toFixed(2) : '-'}
                                                        </TableCell>
                                                    </React.Fragment>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                        <TableBody>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell colSpan={2} style={{ borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="left">
                                                    Total
                                                </TableCell> 
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalFieldActualAmount.toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalFieldGrossAmount.toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalFieldNetAmount.toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalFactoryActualAmount.toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalFactoryGrossAmount.toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                    {totalValues.totalFactoryNetAmount.toLocaleString()}
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                </TableCell>
                                                <TableCell style={{ border: "2px solid black", borderTopWidth: '2px', borderBottomWidth: '2px', borderColor: 'black', borderStyle: 'solid', fontWeight: "bold" }} align="right">
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer> : null}
                            {mergedReportData.length > 0 ?
                                <div className="pt-4">
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Daily Route Summary With Variance Report"}
                                        trigger={() => <input
                                            type="submit"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"
                                        />}
                                        content={() => componentRef.current}
                                    />
                                </div>
                                : null}
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} searchData={selectedSearchValues} mergedReportData={mergedReportData} classes={classes} totalValues={totalValues} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment >
    );
}